import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../shared';
import { ClassificacaoSelectModule } from '../../../classificacao/select';
import { GrupoClassificacaoClassificavelFormComponent } from './grupo-classificacao-classificavel-form.component';

@NgModule({
    imports: [
        SharedModule,
        ClassificacaoSelectModule
    ],
    declarations: [
        GrupoClassificacaoClassificavelFormComponent
    ],
    exports: [
        GrupoClassificacaoClassificavelFormComponent
    ]
})
export class GrupoClassificacaoClassificavelFormModule { }
